import { Maybe } from '@karakuri-web/faq-type'

import { value, values } from './maybe'

export function breadcrumb(url: string, links: { title: string; link: string }[]) {
  const itemListElement = links.map(({ title, link }, index) => ({
    '@type': 'ListItem',
    item: {
      '@id': `${url}${link}`,
      name: title,
    },
    position: index + 1,
  }))
  const breadcrumb = {
    itemListElement,
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    description: 'Breadcrumbs list',
    name: 'Breadcrumbs',
  }
  return breadcrumb
}

export function schemaOrgWebPage(
  siteUrl?: Maybe<string>,
  language?: Maybe<string>,
  defaultDescription?: Maybe<string>,
  defaultTitle?: Maybe<string>,
  buildTime?: string,
  image?: string
) {
  const url = value(siteUrl, '')
  const inLanguage = value(language, '')
  const description = value(defaultDescription, '')
  const name = value(defaultTitle, '')
  return {
    // headline,
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    url,
    inLanguage,
    mainEntityOfPage: url,
    description,
    name,
    // author: {
    //   '@type': 'Person',
    //   name: author
    // },
    // copyrightHolder: {
    //   '@type': 'Person',
    //   name: author
    // },
    copyrightYear: '2019',
    // creator: {
    //   '@type': 'Person',
    //   name: author
    // },
    // publisher: {
    //   '@type': 'Person',
    //   name: author
    // },
    // datePublished: '2019-01-18T10:30:00+01:00',
    dateModified: buildTime,
    image: {
      '@type': 'ImageObject',
      url: image,
    },
  }
}

export function faqPage(
  askMaybe?: Maybe<string>,
  contentsMaybe?: Maybe<
    Maybe<{
      text?: Maybe<string>
      contentFormat?: Maybe<string>
      image?: Maybe<string>
    }>[]
  >
) {
  const ask = value(askMaybe, '')
  const contents = values(contentsMaybe)
  return {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    name: '',
    mainEntity: {
      '@type': 'Question',
      name: ask,
      text: ask,
      answerCount: 1,
      acceptedAnswer: {
        '@type': 'Answer',
        text: contents
          ? contents
              .map(c => c && c.text)
              .filter(c => !!c)
              .join('\n')
          : '',
      },
    },
  }
}
